import { render, staticRenderFns } from "./AssetFaultLog.vue?vue&type=template&id=90560bc2&scoped=true"
import script from "./AssetFaultLog.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetFaultLog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90560bc2",
  null
  
)

export default component.exports